export default "__VITE_ASSET__BBIAFj$z__"